import React, { useState, useEffect } from "react";
import { ThemeColor, ALERT_TIMEOUT, AUTHENTICATION_URL } from "../Config";
import { Link } from "react-router";
import { isValidEmail } from "../Utils";

function ForgotPasswordContent() {
  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //mail id
  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    email_id_to_reset: "",
  });

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //use effect handle submit action
  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //call endpoint
      passwordResetFormRequest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //password reset link email send endpoint
  //password reset from endpoint
  const passwordResetFormRequest = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SEND_PASSWORD_RESET_MAIL",
        email_id_to_reset: resetPasswordDetails.email_id_to_reset,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check success
        if (data.success === true) {
          //set alert state to show error
          setAlert({
            type: "success",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //reset output
          setResetPasswordDetails({
            ...resetPasswordDetails,
            email_id_to_reset: "",
          });
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }
        //hide the spinner
        setSubmitClicked(false);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Sorry. Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);

        //hide the spinner
        setSubmitClicked(false);
      });
  };

  //submit handler for the form
  const onSubmitResetPasswordForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check if mail id valid
    //if not valid return and show error
    if (isValidEmail(resetPasswordDetails.email_id_to_reset) === false) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Entered email address ${resetPasswordDetails.email_id_to_reset} is not valid. Please enter a valid email addess.`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the inputs
  const onChangeResetPasswordForm = (event) => {
    // Update the state with the new value
    setResetPasswordDetails({
      ...resetPasswordDetails,
      [event.target.id]: event.target.value,
    });
  };

  return (
    <div className="p-3">
      <div
        className="container col-md-4 col-md-offset-4"
        style={{ marginTop: "6rem" }}
      >
        {/* Alert for failure */}
        <div
          className={`alert alert-${alert.type} ${
            alert.visible ? "" : "d-none"
          } fade show`}
          role="alert"
          style={{ marginTop: "5rem" }}
        >
          {alert.message}
        </div>

        {/* title */}
        <h1 className="display-6 text-center mt-2">Reset Password</h1>

        {/* Form */}
        <div className="justify-content-center" style={{ width: "100%" }}>
          <form className="mt-5" onSubmit={onSubmitResetPasswordForm}>
            <div className="form-group">
              <label
                className="text-muted me"
                htmlFor="emaiIDInputForgotPassword"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  className="form-control"
                  id="email_id_to_reset"
                  aria-describedby="emailHelp"
                  placeholder="Enter email address"
                  style={{ borderColor: ThemeColor, height: "60px" }}
                  value={resetPasswordDetails.email_id_to_reset}
                  onChange={onChangeResetPasswordForm}
                />
              </div>
            </div>

            <div className="text-center justify-content-center mt-5 d-flex">
              <div
                className={`spinner-border text-dark me-3 align-self-center ${
                  submitClicked ? "" : "d-none"
                }`}
                role="status"
              >
                <span className="sr-only"></span>
              </div>
              <button
                type="submit"
                className="btn btn-secondary fs-3 px-5"
                style={{
                  width: "100%",
                  height: "60px",
                }}
              >
                Send Link
              </button>
            </div>
          </form>
        </div>
        {/* Signup using */}
        <div
          className="justify-content-center text-center"
          style={{ marginTop: "4rem" }}
        >
          <p className="text-muted fs-5 lead">
            don't have an account?{" "}
            <Link to="/signup" className="text-decoration-none">
              Sign Up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordContent;
